import * as React from 'react';
import { AnyAction, Dispatch } from 'redux';

import { GetAllEventActionsRequest } from '../api/definitions/getAllEventActionsRequest';
import * as EntityNormalizers from '../api/normalizers/entityNormalizers';
import * as EventActionNormalizers from '../api/normalizers/eventActionNormalizers';
import { DataRequestActionTypes, InternalActionTypes } from '../constants/actionTypes';

import { RequestAction } from './allActions';
import { runApiRequest, throttleRequests } from './saga/sagaActions';

export interface EventArchivedActionsLoadedAction extends AnyAction {
  type: InternalActionTypes.EventArchivedActionsLoaded;
  result: EntityNormalizers.NormalizedEntityArray<EventActionNormalizers.NormalizedEventActions>;
  eventId: string;
}

export interface RequestEventArchivedActionsAction extends RequestAction {
  type: DataRequestActionTypes.EventArchivedActionsRequested;
  eventId: string;
}

function createEventArchivedActionsLoadedAction(
  eventId: string,
  result: EntityNormalizers.NormalizedEntityArray<EventActionNormalizers.NormalizedEventActions>,
): EventArchivedActionsLoadedAction {
  return {
    eventId,
    result,
    type: InternalActionTypes.EventArchivedActionsLoaded,
  };
}

export function createEventArchivedActionsRequestedAction(
  eventId: string,
  component: React.Component,
  dispatch: Dispatch,
): RequestEventArchivedActionsAction {
  return {
    dispatch,
    eventId,
    requestingComponent: component,
    type: DataRequestActionTypes.EventArchivedActionsRequested,
  };
}

function* loadEventArchivedActions(action: RequestEventArchivedActionsAction) {
  const request = new GetAllEventActionsRequest(action.eventId, action.requestingComponent, action.dispatch);
  yield runApiRequest(
    request,
    // @ts-ignore
    (result: EntityNormalizers.NormalizedEntityArray<EventActionNormalizers.NormalizedEventActions>) =>
      createEventArchivedActionsLoadedAction(action.eventId, result),
  );
}

export function* loadEventArchivedActionsSaga() {
  yield throttleRequests(
    DataRequestActionTypes.EventArchivedActionsRequested,
    loadEventArchivedActions,
    (a: RequestEventArchivedActionsAction) => a.eventId,
  );
}
